// Toggles each FAQ answer independently (several can stay open at once).
// The height animation itself is pure CSS (grid-template-rows); this only
// flips aria-expanded and the .is-open class that CSS reacts to.
(function () {
  document.querySelectorAll('[data-faq]').forEach(function (list) {
    list.querySelectorAll('[data-faq-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var answer = document.getElementById(toggle.getAttribute('aria-controls'));

        toggle.setAttribute('aria-expanded', String(!expanded));
        if (answer) answer.classList.toggle('is-open', !expanded);
      });
    });
  });
})();
